declare global {
  interface Window {
    dataLayer: unknown[]
    gtag: (...args: unknown[]) => void
  }
}

const GA_ID = 'G-TF7LB30XE2'
let initialized = false

function initAnalytics(): void {
  if (initialized) return
  initialized = true

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`
  document.head.appendChild(script)

  window.dataLayer = window.dataLayer || []
  window.gtag = function () {
    window.dataLayer.push(arguments)
  }
  window.gtag('js', new Date())
  window.gtag('config', GA_ID, { send_page_view: false })
}

function trackPageView(path: string, title: string): void {
  if (!initialized) return
  window.gtag('event', 'page_view', { page_path: path, page_title: title })
}

function trackEvent(eventName: string, params?: Record<string, string | number | boolean>): void {
  if (!initialized) return
  window.gtag('event', eventName, params)
}

export { initAnalytics, trackPageView, trackEvent }
